import React, { FC } from "react";
import { Switch, TouchableWithoutFeedback } from "react-native";

import styled from "styled-components/native";

import { spacing, wpdColor } from "../../styles/theme";
import marginBottom, {
  MarginBottomProps,
} from "../../styles/helpers/marginBottom";
import { ExtraSmallTextGood } from "../../styles/Text/extraSmallText";

const Wrapper = styled.View<MarginBottomProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: ${spacing.medium};

  ${(props: MarginBottomProps) => marginBottom(props)};
`;

const ToggleLabel = styled(ExtraSmallTextGood)`
  display: flex;
  margin-left: ${spacing.small};
`;

interface ToggleTypes extends MarginBottomProps {
  onChange?: (newValue: boolean) => void;
  toggleValue: boolean;
  toggleDisabled?: boolean;
  label?: string;
  sliderWidth?: 10;
}

const Toggle: FC<ToggleTypes> = ({
  onChange,
  toggleValue,
  label,
  toggleDisabled,
}) => {
  const onToggle = () => {
    onChange && onChange(!toggleValue);
  };

  return (
    <TouchableWithoutFeedback onPress={onToggle}>
      <Wrapper hasMarginBottom>
        <Switch
          value={toggleValue}
          trackColor={{
            false: wpdColor.backgroundDark,
            true: wpdColor.primary,
          }}
          thumbColor={wpdColor.backgroundLighter}
          // @ts-expect-error field is still used.
          activeThumbColor={wpdColor.backgroundLighter}
          style={{ transform: [{ scaleX: 1.0 }, { scaleY: 1.0 }] }}
          disabled={toggleDisabled}
        />
        <ToggleLabel>{label}</ToggleLabel>
      </Wrapper>
    </TouchableWithoutFeedback>
  );
};

export default Toggle;
